
import {defineComponent, nextTick, onMounted, PropType, reactive, watch} from "vue";
import {DocumentLocator, InvoiceAmountLocatorDetails} from "@dex/squeeze-client-ts";
import Dropdown from 'primevue/dropdown';
import {showDropdownOverlay} from "@/util/StylesHelper";

export default defineComponent({
	name: "InvoiceAmountsForm",
	components: { Dropdown },
	props: {
		invoiceAmount: {
			type: Object as PropType<InvoiceAmountLocatorDetails>,
			default: () => ({}),
		},
		loading: {
			type: Boolean,
			default: false,
		},
		locators: {
			type: Array as PropType<DocumentLocator[]>,
			default: () => [],
		},
	},
	emits: ['update'],
	setup(props, {emit}) {
		/** Current Object of all input-fields */
		const value = reactive<InvoiceAmountLocatorDetails>({});

		onMounted(async () => {
			Object.assign(value, props.invoiceAmount);

			// Emit Validated-Values onMounted. Otherwise there can be validation-errors when editing multiple entries
			emit("update", value);
		});

		/** Watch prop at set value object, because props are not allowed to be mutated */
		watch(props.invoiceAmount, async () => {
			Object.assign(value, props.invoiceAmount);
			emit("update", value);
		})

		/** Triggered on change of any field */
		const update = async () => {
			// need nextTick, because the dropdown don't check the change of a selected element (is to slow)
			await nextTick();
			emit("update", value);
		}

		return {
			value,
			props,
			Dropdown,
			update,
			showDropdownOverlay,
		}
	},
});

